/* eslint-disable max-lines-per-function */
import { Anstellung } from '@/domain/mitarbeiter/features/anlageassistent/content/Anstellungsverhaeltnis/Anstellung';
import { Fristen } from '@/domain/mitarbeiter/features/anlageassistent/content/Anstellungsverhaeltnis/Fristen/Fristen';
import { Bezahlungsart } from '@/domain/mitarbeiter/features/anlageassistent/content/Bezahlung/Bezahlungsart';
import { Sollstunden } from '@/domain/mitarbeiter/features/anlageassistent/content/Bezahlung/Sollstunden/Sollstunden';
import { Arbeitsbereiche } from '@/domain/mitarbeiter/features/anlageassistent/content/Person/Arbeitsbereiche';
import { Kontakt } from '@/domain/mitarbeiter/features/anlageassistent/content/Person/Kontakt';
import { Person } from '@/domain/mitarbeiter/features/anlageassistent/content/Person/Persoenliches';
import { Zusammenfassung } from '@/domain/mitarbeiter/features/anlageassistent/content/Zusammenfassung/Zusammenfassung';
import {
  AnlageassistentContextType,
  SubStepKey,
} from '@/domain/mitarbeiter/features/anlageassistent/types/types';
import {
  faFileContract,
  faListUl,
  faMoneyBill,
  faUser,
} from '@fortawesome/pro-regular-svg-icons';
import { TFunction } from 'i18next';

export function createSubStep(subStepConfig: {
  title: string;
  key: SubStepKey;
  content: React.ReactNode;
}) {
  return subStepConfig;
}

export function createContextConfig({
  t,
}: {
  t: TFunction<'translation', undefined>;
}): AnlageassistentContextType['state'] {
  return {
    currentStepIndex: 0,
    currentSubStepIndex: 0,
    steps: [
      {
        type: 'step',
        key: 'person',
        title: t('domain.mitarbeiter.create.steps.person.title'),
        icon: faUser,
        subSteps: [
          createSubStep({
            title: t(
              'domain.mitarbeiter.create.steps.person.persoenliches.title',
            ),
            key: 'person.persoenliches',

            content: <Person />,
          }),
          createSubStep({
            title: t('domain.mitarbeiter.create.steps.person.kontakt.title'),
            key: 'person.kontakt',

            content: <Kontakt />,
          }),
          createSubStep({
            title: t(
              'domain.mitarbeiter.create.steps.person.arbeitsbereiche.title',
            ),
            key: 'person.arbeitsbereiche',

            content: <Arbeitsbereiche />,
          }),
        ],
      },
      {
        type: 'step',
        key: 'anstellungsverhaeltnis',
        title: t(
          'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.title',
        ),
        icon: faFileContract,
        subSteps: [
          createSubStep({
            key: 'anstellungsverhaeltnis.anstellung',
            title: t(
              'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.anstellung.title',
            ),
            content: <Anstellung />,
          }),
          createSubStep({
            key: 'anstellungsverhaeltnis.fristen',
            title: t(
              'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.fristen.title',
            ),
            content: <Fristen />,
          }),
        ],
      },
      {
        type: 'step',
        key: 'bezahlung',
        title: t('domain.mitarbeiter.create.steps.bezahlung.title'),
        icon: faMoneyBill,
        subSteps: [
          createSubStep({
            title: t(
              'domain.mitarbeiter.create.steps.bezahlung.bezahlungsart.title',
            ),
            key: 'bezahlung.bezahlungsart',
            content: <Bezahlungsart />,
          }),
          createSubStep({
            title: t(
              'domain.mitarbeiter.create.steps.bezahlung.sollstunden.label',
            ),
            key: 'bezahlung.sollstunden',
            content: <Sollstunden />,
          }),
        ],
      },
      {
        type: 'summary',
        key: 'summary',
        title: t('domain.mitarbeiter.create.steps.zusammenfassung'),
        icon: faListUl,
        content: <Zusammenfassung />,
      },
    ],
  };
}
